export default "Logo-symbol-dark.svg"